import React from 'react';
import emailjs from 'emailjs-com'; // Add this at the top of the file

function HomePage() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      zip: e.target.zip.value,
      size: e.target.size.value,
      debris: e.target.debris.value,
      contact: e.target.contact.value,
    };

    console.log("Sending form data:", formData);

    emailjs.send(
      'service_o11rnnd',      // Your EmailJS Service ID
      'template_14runcv',     // Your EmailJS Template ID
      formData,
      'qnUUMz86a6uGS6G4T'     // Your EmailJS Public Key
    )
    .then((response) => {
      console.log('✅ SUCCESS!', response.status, response.text);
      alert("Thanks! We'll contact you shortly.");
    }, (err) => {
      console.log('❌ FAILED', err);
      alert("There was an error sending your request.");
    });
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Dumpster Rentals in Modesto, CA</h1>
      <p style={{ marginBottom: '1rem' }}>Fast, Affordable Roll-Off Dumpsters Delivered to Your Doorstep</p>
      <p style={{ fontSize: '0.9rem', color: 'gray' }}>Call us: (916) 475-9091</p>

      <form onSubmit={handleSubmit} style={{ marginTop: '2rem' }}>
        <div style={{ marginBottom: '1rem' }}>
          <input name="zip" placeholder="ZIP Code" required />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <input name="size" placeholder="Dumpster Size (e.g., 10, 20, 40 yd)" required />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <input name="debris" placeholder="Type of Debris (e.g., household, concrete)" required />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <input name="contact" placeholder="Your Phone or Email" required />
        </div>
        <button type="submit" style={{ padding: '0.5rem 1rem' }}>Request Quote</button>
      </form>
    </div>
  );
}

export default HomePage;
